// extracted by mini-css-extract-plugin
export default {"area":"textArea_area__BeTQr","suggestItem":"textArea_suggestItem__P1l3-"};